var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 7.33334C3.03486 7.33334 3.33333 7.63182 3.33333 8.00001V13.3333C3.33333 13.5102 3.40357 13.6797 3.5286 13.8047C3.65362 13.9298 3.82319 14 4 14H12C12.1768 14 12.3464 13.9298 12.4714 13.8047C12.5964 13.6797 12.6667 13.5102 12.6667 13.3333V8.00001C12.6667 7.63182 12.9651 7.33334 13.3333 7.33334C13.7015 7.33334 14 7.63182 14 8.00001V13.3333C14 13.8638 13.7893 14.3725 13.4142 14.7476C13.0391 15.1226 12.5304 15.3333 12 15.3333H4C3.46957 15.3333 2.96086 15.1226 2.58579 14.7476C2.21071 14.3725 2 13.8638 2 13.3333V8.00001C2 7.63182 2.29848 7.33334 2.66667 7.33334Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52794 0.861919C7.78829 0.601569 8.2104 0.601569 8.47075 0.861919L11.1374 3.52859C11.3978 3.78893 11.3978 4.21104 11.1374 4.47139C10.8771 4.73174 10.455 4.73174 10.1946 4.47139L7.99935 2.27613L5.80409 4.47139C5.54374 4.73174 5.12163 4.73174 4.86128 4.47139C4.60093 4.21104 4.60093 3.78893 4.86128 3.52859L7.52794 0.861919Z",
    fill: "#60666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 0.666656C8.36884 0.666656 8.66732 0.965133 8.66732 1.33332V9.99999C8.66732 10.3682 8.36884 10.6667 8.00065 10.6667C7.63246 10.6667 7.33398 10.3682 7.33398 9.99999V1.33332C7.33398 0.965133 7.63246 0.666656 8.00065 0.666656Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.f762508b233a9a50e5ca2c6e98c7fbbb.svg";